import styled from "styled-components"
import { ActionIcon, Checkbox, Paper } from "@mantine/core"

// Constants
export const FILTER_MENU_WIDTH = 280
export const FILTER_MENU_PADDING = 32
export const FILTER_MENU_OFFSET = -22

export const FilterButtonContainer = styled.div`
    position: relative;
`

export const StyledFilterButton = styled(ActionIcon)`
    border: none;
    background: transparent;
    color: var(--mantine-color-gray-6);
    border-radius: 50% !important;
    width: 40px;
    height: 40px;
    transition: all 0.2s ease;
    position: relative;
    z-index: 1001;

    &:hover {
        background-color: var(--mantine-color-gray-1) !important;
        color: var(--mantine-color-gray-7);
    }

    &[data-expanded] {
        background-color: white;
        color: var(--mantine-color-gray-7);
    }
`

export const StyledPaper = styled(Paper)`
    position: absolute;
    top: ${FILTER_MENU_OFFSET}px;
    right: ${FILTER_MENU_OFFSET}px;
    width: ${FILTER_MENU_WIDTH}px;
    z-index: 1000;
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.3);
`

export const StyledFilterContent = styled.div`
    padding: ${FILTER_MENU_PADDING}px;
    background: #ffffff;
    display: flex;
    flex-direction: column;
    border-radius: 12px;
    overflow: hidden;
`

export const FilterTitle = styled.h3`
    font-size: 16px;
    font-weight: 700 !important;
    margin: 0;
    margin-bottom: 16px;
    line-height: 20px;
    color: #000000;
`

export const StyledFilterSection = styled.div`
    display: flex;
    flex-direction: column;
    margin-bottom: 24px;

    &:last-child {
        margin-bottom: 0;
    }

    h4 {
        font-size: 13px;
        font-weight: 700 !important;
        color: #000000;
        margin: 0 0 12px 0;
        line-height: 18px;
        display: flex;
        align-items: center;
        height: 18px;
    }
`

export const StyledCheckbox = styled(Checkbox)`
    margin-bottom: 12px;

    &:last-child {
        margin-bottom: 0;
    }

    .mantine-Checkbox-body {
        display: flex;
        align-items: center;
    }

    .mantine-Checkbox-inner {
        display: flex;
        align-items: center;
    }

    .mantine-Checkbox-label {
        font-size: 15px;
        color: #000000;
        font-weight: 400 !important;
        line-height: 1;
        padding-left: 8px;
    }

    .mantine-Checkbox-input {
        width: 18px;
        height: 18px;
        border-radius: 4px;
        cursor: pointer;
        /* Uses Mantine theme colors configured in app/static/frontend/design-constants.ts */
        /* Border and checked colors are automatically set from theme.colors.primary */
    }

    .mantine-Checkbox-icon {
        color: white;
    }
`
